export default __webpack_public_path__ + "static/media/banefits-img-4.a5845c93.png";